import * as React from 'react'

const DeviceIcon = props => (
    <svg
        width={props.size || '24'}
        height={props.size || '24'}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M15.5714 2H8.42857C7.63959 2 7 2.89543 7 4V20C7 21.1046 7.63959 22 8.42857 22H15.5714C16.3604 22 17 21.1046 17 20V4C17 2.89543 16.3604 2 15.5714 2Z"
            stroke={props.color || 'currentColor'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12 6H12.01"
            stroke={props.color || 'currentColor'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default DeviceIcon
